import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotListSection from './components/HotListSection';
import FeaturedGridSection from './components/FeaturedGridSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/home';

export default function Home() {
  return (
    <>
      <title>{siteInfo.name} | 每日大赛正能量不打烊 | 网红大瓜实锤曝光</title>
      <meta name="description" content={siteInfo.description} />
      <meta name="keywords" content={siteInfo.keywords} />
      <link rel="canonical" href="https://heiliaochigua.com" />
      <meta property="og:title" content={`${siteInfo.name} | 每日大赛正能量不打烊 | 网红大瓜实锤曝光`} />
      <meta property="og:description" content={siteInfo.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://heiliaochigua.com" />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '黑料吃瓜爆料中心 - 首页',
          description: siteInfo.description,
          url: 'https://heiliaochigua.com',
          isPartOf: {
            '@type': 'WebSite',
            name: '黑料吃瓜爆料中心',
            url: 'https://heiliaochigua.com',
          },
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://heiliaochigua.com',
              },
            ],
          },
        })}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HotListSection />
          <FeaturedGridSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}